module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Foreslåtte videoer","refresh":"Vis nye videoer","footerText":"hjernedates til neste livsnøkkel"},"en":{"title":"Suggested videos","refresh":"Refresh videos","footerText":"braindates to next life key"}}')
  delete Component.options._Ctor
}
